// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.

/**
 * Sends a message to a child iframe.
 *
 * @param {string} type - Message type descriptor.
 * @param {Object} payload - Data to be sent as message payload.
 * @param {string} [targetOrigin="*"] - Specifies the origin of the target window.
 * 
 * This function attempts to post a message to a child iframe identified by the ID 'i_frame'. 
 * If the iframe is not available or has not loaded, a warning is logged to the console.
 */
export const sendMessageToChild = (type, payload, targetOrigin = '*') => {
    const data = {
        type: type,
        payload: payload,
    };

    const iframe = document.getElementById('i_frame');
    if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(data, targetOrigin);
    } else {
        // console.log('Iframe not available or not loaded yet');
        // console.warn('Iframe not available or not loaded yet');
    }
};